<template>
    <div>
        <b-navbar toggleable="lg" type="dark" id="navbar">
            <b-navbar-brand to="/"><a class="brand-tag">
                <img src="../assets/pp_logo_3_white.png" id="logo" width=75% height=auto alt="Product Planet logo"/></a></b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>


            <b-collapse id="nav-collapse" is-nav right>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item right>
                 <a href="https://www.producthunt.com/posts/product-planet?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-product-planet" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=164817&theme=dark" alt="Product Planet - Up-skilling platform for developers and designers | Product Hunt Embed" style="width: 200px; height: 43px;" width="200px" height="43px" /></a>
                </b-nav-item>
                
                <!--<b-nav-item v-on:click="takeChallenges" id="item1" right>For Jobseekers</b-nav-item> -->
                    
                <!-- Using 'button-content' slot -->
                    
             <!--   <b-nav-item to="/companies" item="item2" right>For Companies</b-nav-item> -->
            </b-navbar-nav>
            

        </b-collapse>
    </b-navbar>
</div>
</template>
    


<script>
import firebase from '../services/firebase'

export default {
    name: 'NavBarDark',
    methods: {
        takeChallenges: function() {
            this.$emit('challenge_clicked');
        }
    }
}
</script>

<style scoped>


    .img {
        z-index: 9999;
        cursor: pointer;
    }

    #logo {
        margin-right:0px; 
        padding-right:0px;
        margin-bottom:6px;
        margin-top:6px;
    }

    .navbar-dark.navbar-nav.nav-link {
        color: rgba(255,255,255,1);
    }

    .navbar-dark .navbar-brand {
        margin-left:0px;
    }

    .navbar-dark .navbar-nav .nav-link{
        color:white!important;
        margin-right:20px;
        font-size:16px;
        font-weight: 500;
    }


    .navbar-toggler {
        z-index: 9999;
    }


    .ml-auto {
        color:rgba(255,255,255,1);
        z-index: 999;
    }

    a {
        z-index:999;
    }
   
    .stroke-btn {
        border-color: #fff;
        color: #fff;
    }

    .stroke-btn:hover {
        border-color: #fff;
        color: #fff;
        background-color: transparent;
    }

    .stroke-btn:active {
        border-color: #fff;
        color: #fff;
        background-color: transparent;
    }

</style>

